import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "../common/renderFromPreloadedJSON";
import SpecializedPage from "./SpecializedPage";

whenDomReady(() => {
  if (document.querySelector('[data-hypernova-key="SpecializedPage"]')) {
    renderFromPreloadedJSON(SpecializedPage, "SpecializedPage");
  }
});
